export default __webpack_public_path__ + "static/media/deviceWireframe.c874bd79.webp";